// extracted by mini-css-extract-plugin
export default {"dropdown_label":"dropdown_dropdown_label__SVnyV","hover":"dropdown_hover__cmPyA"};